import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { FeaturedEvents, FeaturedEventsProps } from './FeaturedEvents';
const defaultQueryClient = new QueryClient();

const FeaturedEventsModule = ({ title, tag }: FeaturedEventsProps) => {
  return (
    <QueryClientProvider client={defaultQueryClient}>
      <FeaturedEvents title={title} tag={tag} />
    </QueryClientProvider>
  );
};

export default FeaturedEventsModule;
